// src/store/actions/resetState.ts
export const RESET_STATE = 'RESET_STATE'

export const resetState = () => ({
  type: RESET_STATE,
})
